import * as Api from '../../../extViewmodels';
import { ISelectBoxOption } from '../../../web/components/SelectBox';

export const getSystemOfRecordOptions = (
	industry: Api.Industry
): ISelectBoxOption<Api.ChiroSystemOfRecord | Api.SystemOfRecord | string>[] => {
	const baseOption: ISelectBoxOption<string> = { title: 'Select One', value: '' };

	if (industry === Api.Industry.Chiropractic) {
		return [
			baseOption,
			...Api.AllChiroSystemsOfRecord.map(systemOfRecord => ({
				title: systemOfRecord,
				value: systemOfRecord,
			})),
		];
	}

	return [
		baseOption,
		...[...Api.AllSystemsOfRecord].sort().map(systemOfRecord => ({
			title: systemOfRecord,
			value: systemOfRecord,
		})),
	];
};
